// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".announcement-space{margin-top:50px!important}.announcement{position:absolute;z-index:999;top:0;left:258px;width:calc(100% - 258px);height:50px;background-image:linear-gradient(92deg,#fffff4,#fff7fd 31%,#f7ffff 67%,#fafffa);font-size:14px;font-weight:500;cursor:pointer}.announcement a{height:100%}.announcement a:hover{text-decoration:none}.announcement a:hover ::v-deep .sb-icon .mask{background-color:#2470cb!important}", ""]);
// Exports
module.exports = exports;
